import { render, staticRenderFns } from "./AlertVettedOffer.vue?vue&type=template&id=46c77f48"
import script from "./AlertVettedOffer.vue?vue&type=script&lang=js"
export * from "./AlertVettedOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports